import React from 'react';

import CONFIG from '../../../config';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';


function Utilisateur({ data }) {
  return (
    <>
      <div className='divide-x col-span-12 grid grid-cols-9 gap-x-2 shrink-0 p-2 mb-2 bg-gray-100 rounded-md hover:border-ame-orange my-shadow cursor-pointer' onClick={() => window.open(CONFIG.BASE_URL + "/intranet/fiche/" + data._id, '_blank').focus()}>
        <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {(data.nom.trim() === '' && data.prenom.trim() === '') ? 'Sans nom' : data.nom}
        </div>
        <div className='col-span-2 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {(data.nom.trim() === '' && data.prenom.trim() === '') ? '(' + data._id + ')' : data.prenom}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.roles.role_client ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.roles.role_commercial ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.roles.role_admin_read ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.roles.role_admin_write ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
        <div className='col-span-1 text-ellipsis overflow-hidden whitespace-nowrap pl-2'>
          {!data.roles.role_comptable ? <CloseIcon className='text-red-600'></CloseIcon> : <CheckIcon className='text-green-600'></CheckIcon>}
        </div>
      </div>
    </>
  );
}

export default Utilisateur;